import { render, staticRenderFns } from "./CompareChart.vue?vue&type=template&id=1a89ac48&scoped=true"
import script from "./CompareChart.vue?vue&type=script&lang=js"
export * from "./CompareChart.vue?vue&type=script&lang=js"
import style0 from "./CompareChart.vue?vue&type=style&index=0&id=1a89ac48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a89ac48",
  null
  
)

export default component.exports